import { StatusBadge } from '@/components/common/StatusBadge';
import {
  SUBMISSION_TYPE_LABELS,
  SUBMISSION_TYPE_TONE,
} from '../constants/instituteSubmission.constants';
import type { SubmissionType } from '../types/instituteSubmission.types';

interface InstituteSubmissionTypeBadgeProps {
  submissionType: SubmissionType;
  className?: string | undefined;
}

export function InstituteSubmissionTypeBadge({
  submissionType,
  className,
}: InstituteSubmissionTypeBadgeProps) {
  return (
    <StatusBadge tone={SUBMISSION_TYPE_TONE[submissionType]} className={className}>
      {SUBMISSION_TYPE_LABELS[submissionType]}
    </StatusBadge>
  );
}
